






















































import { Component, Prop, Watch } from 'vue-property-decorator';
import { Store } from '@/enums/Store';
import { Locale } from '@/enums/Locale';
import { TicketCategory } from '@/util/TicketCategory';
import { formatPriceByCurrency as formatPrice } from '@/util/price';
import { MegaOption } from '@/util/MegaOption';
import { Member } from '@/util/Member';
import { Event } from '@/util/Event';
import FormMega from '@/components/Form/InputComponents/FormMega.vue';
import Validatable from '@/components/Validatable.vue';
import { namespace } from 'vuex-class';
import { Currency } from '@/enums/Currency';
import { InputType } from '@/enums/InputType';
import FormInput from '@/components/Form/InputComponents/FormInput.vue';
import { discountRuleCreator } from '@/util/Rules';
import { extend } from 'vee-validate';
import { DiscountCheckInterface } from '@/types/DiscountCheck';
import { OrderItem } from '@/util/OrderItem';
import { Discount } from '@/util/Discount';

const APP = namespace(Store.APP);
const EVENT = namespace(Store.EVENT);
const MEMBER = namespace(Store.MEMBER);
const CART = namespace(Store.CART);
const PAYMENT_INTERVAL = namespace(Store.PAYMENT_INTERVAL);

@Component({
  components: { FormMega, FormInput }
})
export default class TicketCategorySelection extends Validatable {
  @Prop({ required: true }) member!: Member;
  @Prop({ required: true }) index!: number;
  @APP.State('locale') locale!: Locale;
  @PAYMENT_INTERVAL.State('paymentContributionInterval')
  paymentContributionInterval!: string;
  @PAYMENT_INTERVAL.Action('setPaymentContributionInterval')
  setPaymentContributionInterval!: (text: string) => void;
  @APP.State('currency') currency!: Currency;
  @EVENT.Getter('selectedEventObject') event!: Event;
  @MEMBER.Action('setMemberDiscount') setMemberDiscount!: (
    response: DiscountCheckInterface
  ) => void;
  @APP.Mutation('ADD_ERROR') addError!: (error: Error) => void;
  @CART.Getter('orderItem') orderItem!: (member: Member) => OrderItem;
  @MEMBER.State('members') members!: Member[];
  isDiscountButtonDisabled = false;
  showDiscountInput = false;
  showDiscountResetButton = true;
  currentCategoryId = this.ticketCategoryId;
  hasAutoDiscount = false;
  autoDiscountFromCount: number | null = null;
  discount: null | Discount = null;

  TEXT = InputType.TEXT;

  @Watch('member', { deep: true })
  updateMember() {
    this.$emit('update:member', this.member);
    if (this.member.ticketCategoryId !== undefined) {
      this.updatePaymentIntervalContributionText();
    }
  }

  async mounted() {
    this.updatePaymentIntervalContributionText();
    await this.getAutoDiscounts();
    this.applyAutoDiscount();
    console.log(this.member);
  }

  applyAutoDiscount() {
    if (this.discount) {
      if (this.index > this.discount?.autoFromCount - 1) {
        this.members[this.index].discountCode = this.discount.code;
        this.hasAutoDiscount = true;
        this.validateDiscount();
      }
    }
  }

  async getAutoDiscounts() {
    const response = await this.$api.get(
      `/discount/auto/${this.currentCategoryId}`,
      {},
      false
    );

    this.discount = new Discount(response);
  }

  get hasEventDiscounts(): boolean {
    //todo: add hasDiscounts to event object
    return true;
  }

  resetDiscount() {
    this.member.discount = undefined;
    this.member.discountCode = undefined;
  }

  validateDiscount() {
    this.isDiscountButtonDisabled = true;

    const discountCheck = discountRuleCreator(
      this.$api,
      this.member,
      this.currency,
      this.index,
      this.addError,
      this.setMemberDiscount
    );
    extend(this.member.id, {
      ...discountCheck,
      message: this.$t('discount-code-invalid').toString()
    });
    if (this.$refs.discountInput) {
      (this.$refs.discountInput as Validatable).validate();
    }
    this.isDiscountButtonDisabled = false;
  }

  get ticketCategoryId() {
    return this.member.ticketCategoryId;
  }

  set ticketCategoryId(value) {
    this.validateDiscount();
    this.member.ticketCategoryId = value;
  }

  updatePaymentIntervalContributionText() {
    this.event.ticketCategories.forEach((ticketCategory) => {
      if (ticketCategory.entityId == this.ticketCategoryId) {
        const text = this.$t(ticketCategory.paymentInterval + '-contribution').toString();
        this.setPaymentContributionInterval(text);
      }
    });
  }

  get megaOptions() {
    if (this.event) {
      return this.event.ticketCategories.map(
        ({ shortDescription, entityId, name, price }: TicketCategory) => {
          const orderItem = this.orderItem(this.member);

          if (this.member.ticketCategoryId == entityId) {
            return new MegaOption(
              shortDescription as string,
              entityId,
              name,
              formatPrice(orderItem.price, this.currency),
              name
            );
          }

          return new MegaOption(
            shortDescription as string,
            entityId,
            name,
            formatPrice(price, this.currency),
            name
          );
        }
      );
    }
    return [];
  }
}
